import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import axios from "axios";

// Public Pages (German)
import HomePage from "@/pages/public/HomePage";
import CategoryPage from "@/pages/public/CategoryPage";
import AllCategoriesPage from "@/pages/public/AllCategoriesPage";
import ImpressumPage from "@/pages/public/ImpressumPage";
import DatenschutzPage from "@/pages/public/DatenschutzPage";

// Admin Pages (Turkish)
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminTariffs from "@/pages/admin/AdminTariffs";
import AdminProviders from "@/pages/admin/AdminProviders";
import AdminAffiliateLinks from "@/pages/admin/AdminAffiliateLinks";
import AdminPages from "@/pages/admin/AdminPages";
import AdminFAQs from "@/pages/admin/AdminFAQs";
import AdminGoogleIntegrations from "@/pages/admin/AdminGoogleIntegrations";
import AdminSEO from "@/pages/admin/AdminSEO";

// Components
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Auth guard component with proper loading state
const ProtectedRoute = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("admin_token");
      setIsAuthenticated(!!token);
      setIsChecking(false);
    };
    checkAuth();
  }, [location]);

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-8 h-8 border-4 border-electric-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

function App() {
  useEffect(() => {
    // Seed database on first load
    const seedDb = async () => {
      try {
        await axios.post(`${API}/seed`);
      } catch (e) {
        console.log("Database may already be seeded");
      }
    };
    seedDb();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes (German Frontend) */}
          <Route path="/" element={<HomePage />} />
          <Route path="/strom" element={<CategoryPage slug="strom" />} />
          <Route path="/strom/:subpage" element={<CategoryPage slug="strom" />} />
          <Route path="/dsl-internet" element={<CategoryPage slug="dsl-internet" />} />
          <Route path="/dsl-internet/:subpage" element={<CategoryPage slug="dsl-internet" />} />
          <Route path="/handyvertrag" element={<CategoryPage slug="handyvertrag" />} />
          <Route path="/handyvertrag/:subpage" element={<CategoryPage slug="handyvertrag" />} />
          <Route path="/versicherungen" element={<CategoryPage slug="versicherungen" />} />
          <Route path="/versicherungen/:subpage" element={<CategoryPage slug="versicherungen" />} />
          <Route path="/kredit-kreditkarte" element={<CategoryPage slug="kredit-kreditkarte" />} />
          <Route path="/kredit-kreditkarte/:subpage" element={<CategoryPage slug="kredit-kreditkarte" />} />
          <Route path="/kategorien" element={<AllCategoriesPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />

          {/* Admin Routes (Turkish Panel) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/kategoriler" element={<ProtectedRoute><AdminCategories /></ProtectedRoute>} />
          <Route path="/admin/tarifeler" element={<ProtectedRoute><AdminTariffs /></ProtectedRoute>} />
          <Route path="/admin/saglayicilar" element={<ProtectedRoute><AdminProviders /></ProtectedRoute>} />
          <Route path="/admin/affiliate-linkler" element={<ProtectedRoute><AdminAffiliateLinks /></ProtectedRoute>} />
          <Route path="/admin/sayfalar" element={<ProtectedRoute><AdminPages /></ProtectedRoute>} />
          <Route path="/admin/sss" element={<ProtectedRoute><AdminFAQs /></ProtectedRoute>} />
          <Route path="/admin/google-entegrasyonlari" element={<ProtectedRoute><AdminGoogleIntegrations /></ProtectedRoute>} />
          <Route path="/admin/seo" element={<ProtectedRoute><AdminSEO /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
